module.exports = __webpack_public_path__ + "img/bigModImg.e99335cf.png";